<template>
  <div>
    <div class="mb-10">
      <p class="font-weight-bold">Interactive calculators are self-help tools. All examples are hypothetical
          and are
          for illustrative purposes only.</p>
        <p class="mb-0">{{ loanOfficer.company.companyName }} is licensed to conduct business only in {{ statesString }}.</p>
        <p class="mb-0">
          {{ loanOfficer.company.companyName }} {{ loanOfficer.company.address }},
          {{ loanOfficer.company.city }}, {{ loanOfficer.company.state }},
          {{ loanOfficer.company.zip }}.
        </p>
        <p class="mb-0">NMLS #{{ loanOfficer.company.nmls }}</p>
        <p class="my-4"> A prospective applicant may be assigned to a loan officer licensed in the prospective
          applicant’s state.</p>
        <p class="text-justify">
          These materials have not been approved or endorsed by FHA or any other government agency.
          {{ loanOfficer.company.companyName }} is not affiliated with your current lender. Equal
          Housing Opportunity. Rates, Program, Fees, and Guidelines are subject to change without
          notice. Restrictions apply. Not all will qualify. Not a Loan Approval and not a commitment to lend.
        </p>
    </div>
    <p>
      The attached documents illustrate estimates only, based on information provided by you,
      currently available interest rates, fees, HUD and Lender guidelines & policies, all of which
      are subject to change at any time. Future projections of property values, loan balances, line
      of credit availability, monthly payment options, interest rates, etc. are estimates only and
      are not guaranteed.
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    loanOfficer() {
      return this.$store.state.loanOfficer.info;
    },
    statesString() {
      return this.$store.state.loanOfficer.info.states.map((i) => i.state).join(', ');
    },
  }
};
</script>
